export enum EVENT_SETUP_SECTIONS {
  start,
  basic,
  formats,
  flights,
  rounds,
  // Temporarily disable fees screen due to https://code.talpor.com/club15/frontend/-/issues/900
  // fees,
  publish,
  players
}
